import type { UserSticker } from '@/models/user/custom-sticker';
import cn from '@/utils/merge-class-names';
import { StickerItem } from './sticker-item';
import { StickerUploadButton } from './sticker-upload-button';

interface Props {
  stickers: UserSticker[];
  className?: string;
  selectedStickers?: number[];
  onClick?: (sticker: UserSticker) => void;
}

export function StickerGrid({ stickers, selectedStickers, onClick, className }: Props) {
  return (
    <div className={cn('grid auto-rows-fr grid-cols-4 gap-2 px-2 py-1 pb-safe-offset-1 place-items-center', className)}>
      <StickerUploadButton key='upload' />

      {stickers.map((sticker) => (
        <StickerItem
          key={sticker.Id}
          className='mobile:xs:size-24'
          sticker={sticker}
          isSelected={selectedStickers?.includes(sticker.Id)}
          onClick={() => onClick?.(sticker)}
        />
      ))}
    </div>
  );
}
